import api from '../connectors/Api'

const API = api()

export default {
  namespaced: true,
  state: {
    reports: {}
  },
  mutations: {
    setReport (state, { campaignId, report }) {
      const newReports = { ...state.reports }
      newReports[campaignId] = report
      state.reports = newReports
    }
  },
  getters: {
    /* getReport: (state) => (campaignId) => {
      const shearchId = parseInt(campaignId)
      return state.items.find((i) => i.id === shearchId)
    } */
  },
  actions: {
    getReport ({ commit, state, dispatch }, campaignId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getCampaignReport(token, campaignId)
            .then((res) => {
              commit('setReport', { campaignId, report: res.body })
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    }
  }
}
